var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "result" }, [
    _c(
      "div",
      {
        style: `background-image: url(${_vm.image}); background-position: center; background-size: cover; height: 100%`,
      },
      [
        _c("div", { staticClass: "result__overlay" }, [
          _c("div", { staticClass: "result__overlay__outter-border" }, [
            _c("div", { staticClass: "result__overlay__inner-border" }, [
              _c("div", { staticClass: "result__logo-container" }, [
                _c("img", {
                  staticClass: "result__white-logo",
                  attrs: {
                    src: require("@/assets/images/LOGO-OUB-WHITE.svg"),
                    alt: "Officine Universelle Buly",
                  },
                }),
              ]),
              _c("span", { staticClass: "result__title" }, [
                _vm._v(" " + _vm._s(_vm.$t("result.title")) + " "),
              ]),
              _vm.concern
                ? _c("span", { staticClass: "result__concern" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("result.concern")) +
                        ": " +
                        _vm._s(_vm.concern) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "result__cards-container" },
                [
                  _vm._l(_vm.products, function (product) {
                    return _c(
                      "div",
                      {
                        key: product.id,
                        class: [
                          "result__products-container",
                          {
                            "result__products-container__one-product":
                              _vm.isOneProductOnly,
                          },
                        ],
                      },
                      [
                        _c("v-product", {
                          staticClass: "result__product",
                          attrs: {
                            price: product.price,
                            currencyCode: product.currencyCode,
                            title: product.title,
                            description: product.description || "",
                            image: product.bulyImage || "",
                            careTag: product.bulyCareTag,
                            isSelected: _vm.selected.includes(
                              product.bulyShopifyProductId
                            ),
                          },
                          on: {
                            select: function ($event) {
                              return _vm.onSelect(product.bulyShopifyProductId)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm.tip
                    ? _c(
                        "div",
                        {
                          staticClass: "result__officine",
                          class: [
                            "result__officine",
                            {
                              "result__officine__one-product":
                                _vm.isOneProductOnly,
                            },
                          ],
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "result__officine__title" },
                            [_vm._v(" " + _vm._s(_vm.$t("result.tip")) + " ")]
                          ),
                          _c("p", { staticClass: "result__officine__text" }, [
                            _vm._v(" " + _vm._s(_vm.tip.description) + " "),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c("div", { staticClass: "result__cta" }, [
                _c(
                  "div",
                  { staticClass: "result__cta__add-cart-container" },
                  [
                    _c(
                      "v-button",
                      {
                        staticClass: "result__cta__button",
                        attrs: { isResult: true, href: _vm.addCart },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("result.addCart")) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "result__cta__button-container" },
                  [
                    _c("folding-button"),
                    _c(
                      "v-button",
                      {
                        directives: [
                          {
                            name: "touch",
                            rawName: "v-touch:tap",
                            value: _vm.newSearch,
                            expression: "newSearch",
                            arg: "tap",
                          },
                        ],
                        staticClass: "result__cta__button",
                        attrs: { isResult: true },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("result.newSearch")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
    _c("div", [
      _c(
        "a",
        {
          staticClass: "result__link_cover",
          attrs: { href: _vm.$t("endPage.bulyUrl") },
        },
        [
          _vm.$te("endPage.bulyImage.0")
            ? _c("v-cover", {
                staticClass: "result__cover",
                attrs: {
                  image: _vm.$t("endPage.bulyImage.0.url"),
                  title: _vm.$t("result.endTitle"),
                  cta: _vm.$t("result.discover"),
                  dark: true,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }